exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".plain-card[data-v-b09871da] {\n  background-color: white;\n  padding: 20px;\n  position: relative;\n  box-shadow: 3px 1px 5px #ccc;\n}\n.plain-card[data-v-b09871da]:not(:first-child) {\n  margin-top: 30px;\n}\n.plain-card h2[data-v-b09871da] {\n  margin-bottom: 20px;\n}\n.plain-card table[data-v-b09871da] {\n  width: 100%;\n}\n.plain-card table td[data-v-b09871da], .plain-card table th[data-v-b09871da] {\n  border: 1px solid black;\n  padding: 6px;\n  text-align: right;\n}\n.plain-card table tbody th[data-v-b09871da] {\n  min-width: 190px;\n}\n", ""]);

// exports
